
import { mapState } from 'vuex';

export default {
    computed: {
        ...mapState({
            key: state => state.refresh_count
        })
    },
};
